<template>
<!-- 页脚组件 -->
  <div class='footBox'>
    <v-row  class="fill-height" justify="space-around">
      <v-card
        color='rgb(212, 217, 223,0)'
        class="ma-4"
        :width="listWidth"
        min-width="120"
        elevation=0
        v-for='li in footerList' :key='li.index'
      >
      <v-list style="background-color:rgba(1,1,1,0)">
        <v-list-group v-model="active[li.index]">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="li.title" class="white--text" style="font-size:1rem"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-show="child.path"
            v-for="child in li.list"
            :key="child.oath"
            :width="listWidth"
            link
            :to='child.path'
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.label" style="color:#6c89b3"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-show="child.href"
            v-for="child in li.list"
            :key="child.href"
            :width="listWidth"
            link
            @click="tohref(child.onlyPc, child.href)"
            target='_blank'
          >
            <v-list-item-content>
              <v-list-item-title v-text="child.label" style="color:#6c89b3"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
      </v-card>
      <v-card
        color='rgb(212, 217, 223,0)'
        class="ma-4 footspace"
        height="70px"
        width="5rem"
        elevation=0
      ></v-card>
      <v-card
        color='rgb(212, 217, 223,0)'
        class="ma-4 footImage"
        height="150px"
        width="20rem"
        min-width="180"
        elevation=0
      >
        <img src="../assets/images/foot.png" style="height:150px;margin:auto;margin-top:30px" alt="">
      </v-card>
    </v-row>
    <p style="text-align:center;margin:auto;margin-top:1rem;font-size:14px;color:#6c89b3">Copyright ©JXFM河北嘉旭福美数据信息有限公司,Inc.All rights reserved.
      <img src="../assets/images/foot_img.png" style="width:14px"><a style="text-align:center;margin:auto;margin-top:1rem;font-size:14px;color:#6c89b3;text-decoration:none" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13062602000103">冀公网安备 13062602000103号 </a><a style="text-align:center;margin:auto;margin-top:1rem;font-size:14px;color:#6c89b3;text-decoration:none" href="http://beian.miit.gov.cn">网站备案号：冀ICP备18005364号-2</a></p>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >提示</v-toolbar>
        <v-card-text>
          <div class="body_text pa-12" v-text='dialog_tip'></div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="dialog= false"
          >关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'footContent',

  props: {
    active: Array,
    listWidth: String

  },

  data: () => ({
    // 列表宽度
    // listWidth: '10rem',
    // 页脚列表是否展开
    // active: true,
    // 页脚列表
    dialog: false,
    dialog_tip: '请使用PC端打开',
    mobile: true,
    footerList: [{
      index: 0,
      title: '加入我们',
      list: [{
        label: '社会招聘',
        path: '/zhaopin',
        onlyPc: false
      }]
    }, {
      index: 1,
      title: '联系我们',
      list: [{
        label: '预约参观',
        path: '/contact',
        onlyPc: false
      }, {
        label: '供应商入口',
        href: 'http://gys.hbjxfm.com:8380/',
        onlyPc: true
      }]
    }]
  }),

  mounted () {
    this.mobile = this.ismobile()
  },

  methods: {
    // 判断是否为移动端
    ismobile () {
      var mobileArry = ['iPhone', 'iPad', 'Android', 'Windows Phone', 'BB10; Touch', 'BB10; Touch', 'PlayBook', 'Nokia']
      var ua = navigator.userAgent
      var res = mobileArry.filter(function (arr) {
        return ua.indexOf(arr) > 0
      })
      return res.length > 0
    },
    tohref (onlyPc, href) {
      if (!this.mobile) {
        window.open(href, '_blank')
      } else {
        if (onlyPc) {
          this.dialog = true
        } else {
          window.open(href, '_blank')
        }
      }
    }
  }
}
</script>

<style scoped>
.v-application a {
    color: var(--secondary);
}
.v-application .primary--text {
    color:var(--secondary) !important;
    caret-color: #3c8cff !important;
}
.v-card > *:last-child:not(.v-btn):not(.v-chip) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

</style>
